<div class="wrap-rounded-link">
  <app-rounded-link *ngFor="let item of list" color="primary" [link]="item.link" [icon]="item.icon" [squareMode]="true"
    [kpi]="item.kpi" showKpi="true" [type]="'SMALL'" [text]="item.title"
    appTooltip="{{ 'MenuTooltips.'+item.id | translate}}"></app-rounded-link>
</div>

<div *ngIf="canViewTimeline" class="tracking-timeline">
  <app-tracking-timeline [prop]="prop"></app-tracking-timeline>
</div>